/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Banner file validation and FileReader helpers for EventCreation.
 * @module utils/eventCreation/eventBannerUpload
 */

const ALLOWED_BANNER_TYPES = ["image/jpeg", "image/jpg", "image/png"];
const MAX_BANNER_SIZE_BYTES = 5 * 1024 * 1024;

export const validateEventBannerFile = (file) => {
  if (!file) {
    return { valid: false, reason: "missing" };
  }
  if (!ALLOWED_BANNER_TYPES.includes(file.type)) {
    return { valid: false, reason: "type" };
  }
  if (file.size > MAX_BANNER_SIZE_BYTES) {
    return { valid: false, reason: "size" };
  }
  return { valid: true, file };
};

export const readEventBannerAsDataUrl = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve({
        dataUrl: event.target.result,
        name: file.name,
        format: file.type,
      });
    };
    reader.onerror = () => reject(new Error("BANNER_READ_FAILED"));
    reader.readAsDataURL(file);
  });
